export function removeFromSessionStorage(key) {
  sessionStorage.removeItem(key);
}

export function removeFromLocalStorage(key) {
  localStorage.removeItem(key);
}

export function saveToSessionStorage(key, data) {
  sessionStorage.setItem(key, JSON.stringify(data));
}

export function saveToLocalStorage(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function getFromSessionStorage(key, defaultValue = []) {
  return getFromStorage(sessionStorage, key, defaultValue);
}

export function getFromLocalStorage(key, defaultValue = []) {
  return getFromStorage(localStorage, key, defaultValue);
}

export const getFromStorage = (storage, key, defaultValue = []) => {
  try {
    if (storage.getItem(key)) return JSON.parse(storage.getItem(key));
  } catch (e) {
    return defaultValue;
  }
  return defaultValue;
};
